import type { App } from "vue";

export interface Plugin {
  install(app: App): void;
}

import floatingVue from "./floating-vue";
import motion from "./motion";
import directiveLoading from "./directive-loading";
import directiveErrorShake from "./directive-error-shake";
import directiveAnimatePop from "./directive-animate-pop";

export const plugins: Plugin[] = [floatingVue, motion, directiveLoading, directiveErrorShake, directiveAnimatePop];
